import { SessionTopic } from './../models/session-topic';
import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Session } from '../models/session';
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../models/contents-mandatory';


@Injectable()
export class SessionTopicService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  getAllTopicList(event_id: string): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + event_id + Constants.SESSION_TOPIC_URL);
    }
    return null;
  }

  getTopicList(event_id: string, session_id: string) {
    console.log("Topic Session ID", session_id);

    if (this.utilityService.isLogged()) {


      let topic_list = this.db.list(
        Constants.EVENT_URL + '/' + event_id + Constants.SESSION_TOPIC_URL,
        refs => refs.orderByChild('sessionId').equalTo(session_id)
      )
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.val();
            const id = a.payload.key;
            return {
              $key: id,
              ...data
            };
          });
        });
      // .pipe(items => {
      //   console.log("ITEMS",items);
      //   return items.map(a => {
      //     const data = a['payload'].val();
      //     const key = a['payload'].key;
      //     return { key, data };
      //   });
      // });

      return topic_list;

      // let topic_list = this.db.list(
      //   Constants.EVENT_URL + '/' + event_id + Constants.SESSION_TOPIC_URL,
      //   refs => refs.orderByChild('sessionKey').equalTo(session_id)
      // ).valueChanges()

      // return topic_list;

    }
    return null;
  }

  getSessionList(id: string): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.SESSION_URL);
    }
    return null;
  }

  getSingleSessionList(eventId: string, sessionId): Observable<Session> {
    if (sessionId != null) {
      let data: AngularFireObject<Session> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SESSION_URL + "/" + sessionId);
      return data.valueChanges();
    }
    return null;
  }

  updateSessionPosition(eventID, sessionList, sessionDeletedIdList) {
    /*if(sessionDeletedIdList != null) {
      for(let id of sessionDeletedIdList) {
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.SESSION_URL+'/'+id).set(null);
      } for(let item of sessionList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.SESSION_URL+"/"+key).update({position:item.position});
     }*/
    //} else {
    for (let item of sessionList) {
      console.log(item.$key, item.position);
      let key = item.$key;
      this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + key).update({ position: item.position });
    }
    //}
  }

  addSessionTopicDetails(sessionTopicDetails: SessionTopic, eventID: string) {
    if (sessionTopicDetails.$key.length > 0) {
      return this.updateSessionTopicDetails(sessionTopicDetails, eventID);
    } else {
      delete sessionTopicDetails.$key;
      return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL).push(sessionTopicDetails).key;
    }
  }

  updateSessionTopicDetails(sessionTopicDetails: SessionTopic, eventID: string): Promise<any> {
    let sessionTopicKey = sessionTopicDetails.$key;
    delete sessionTopicDetails.$key;
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL + '/' + sessionTopicKey).set(sessionTopicDetails);
  }

  deleteSessionTopicById(topicId: string, eventID: string): Promise<any>{
    if(topicId.length > 3)
      return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL).remove(topicId);
    else 
      return new Promise((resolve, reject)=>{
        resolve({});
      })
  }

  addSessionDetails(sessionDetails: Session, eventID: string) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).push(sessionDetails).key;
  }

  updateSessionDetails(sessionDetails: Session, eventID: string, sessionId: string): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + sessionId).set(sessionDetails);
  }

  

  deleteSessionID(event: Session, eventID: string, sessionList) {
    let abc: Array<any> = new Array();
    if (event.headerContentMandatoryList) {
      for (let key in event.headerContentMandatoryList) {
        if (event.headerContentMandatoryList.hasOwnProperty(key)) {
          abc.push(event.headerContentMandatoryList[key]);
        }
      }
      let category = 'Menu';
      for (let i = 0; i < abc.length; i++) {
        console.log(event.headerContentMandatoryList[i]);
        this.getContentsMandatoryInfo(eventID, abc[i]).subscribe(event => {
          if (event) {
            if (event.category == 'Session') {
              let storageReff = firebase.storage().ref();
              storageReff.child(`${"/" + eventID + Constants.Contents_Mandatory_URL + "/" + category}/${event.filename}`).delete();
            }
          }
        });
        this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.Contents_Mandatory_URL).remove(abc[i]);
      }
    }
    if (sessionList.length == 0) {
      return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).remove(event.$key);
    } else {
      this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).remove(event.$key);
      let i = 0;
      for (let item of sessionList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        var data = this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + key).update({ position: item.position });
        if (i == sessionList.length - 1) { return data }; i++
      }
    }
  }


  getContentsMandatoryInfo(eventId, cid): Observable<ContentsMandatory> {
    console.log('cid', cid, 'eventid', eventId)
    let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL + '/' + cid);
    return data.valueChanges();
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/session-topic.service.ts